export default __webpack_public_path__ + "static/gmail-hero-image-e3ee9500691528222fd858fece740345.webp";